<template>
  <DialogOverlay
    data-slot="dialog-overlay"
    v-bind="delegatedProps"
    :class="cn(dialogOverlayVariants(), props.class)"
  >
    <slot />
  </DialogOverlay>
</template>

<script setup lang="ts">
import { reactiveOmit } from "@vueuse/core";
import { DialogOverlay, type DialogOverlayProps } from "reka-ui";
import type { HTMLAttributes } from "vue";
import { dialogOverlayVariants } from "./variants";
import { cn } from "@/lib/utils";

const props = defineProps<
  DialogOverlayProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = reactiveOmit(props, "class");
</script>
